import React, { useState } from "react";
import {
  Button,
  Form,
  Radio,
  RadioGroup,
  SelectPicker,
  DateRangePicker,
  useToaster,
  Notification,
  IconButton,
  DatePicker,
} from "rsuite";
import Header from "../component/Header";
import SearchIcon from "@rsuite/icons/Search";
import axios from "axios";
import Table from "react-bootstrap/Table";
import moment from "moment";
import * as XLSX from "xlsx";
import { firstDay } from "../Constants";
import ExportIcon from "@rsuite/icons/Export";
import { Table2XLSX } from "../functions";

const ViewAttendance = () => {
  const [radio, setRadio] = useState("A");

  const [selectedDate, setselectedDate] = useState(new Date());
  const [selectedNameID, setselectedNameID] = useState("");
  const [LabourList, setLabourList] = useState([]);
  const [dataList, setdataList] = useState([]);
  const [dataList2, setdataList2] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [processing1, setProcessing1] = useState(false);
  const [processing2, setProcessing2] = useState(false);
  const toaster = useToaster();
  const [selectedLabour, setSelectedLabour] = useState("");
  const [selectedDateRange, setselectedDateRange] = useState([
    new Date(),
    new Date(),
  ]);

  const [attendance, setAttendance] = useState("");
  const [amount, setAmount] = useState("");

  const [column, setColumn] = useState([
    { field: "Date", title: "Date" },
    { field: "Attendance", title: "Attendance" },
    { field: "Rate", title: "Rate" },
    { field: "Salary", title: "Salary" },
    { field: "Tea", title: "Tea" },
    { field: "Total", title: "Total" },
    { field: "SiteName", title: "SiteName" },
  ]);

  const column2 = [
    { field: "Name", title: "Name" },
    { field: "Date", title: "Date" },
    { field: "Attendance", title: "Attendance" },
    { field: "Rate", title: "Rate" },
    { field: "Salary", title: "Salary" },
    { field: "Tea", title: "Tea" },
    { field: "Total", title: "Total" },
    { field: "SiteName", title: "SiteName" },
  ];

  const getLabourList = () => {
    setLabourList([]);
    axios
      .get("https://api.laxmaninterior.in/GetLabours.php")
      .then(function (response) {
        const data1 = response.data;
        if (data1.status === 1) {
          data1.Data.forEach((r) => {
            setLabourList((a) => {
              return [...a, { id: r.SrNo, value: r.Name, label: r.Name }];
            });
          });
        }
        if (data1.status === 0) {
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleRadio = (e) => {
    setRadio(e);
  };

  function handleExport() {
    setProcessing1(true);
    if (selectedNameID === "") {
      toaster.push(
        <Notification type="error" header="Error" duration={1000}>
          Please enter Labour name
        </Notification>,
        { placement: "topEnd" }
      );
      setProcessing1(false);
      return;
    }
    const datatoSend = { LabourID: selectedNameID };
    axios
      .post(
        "https://api.laxmaninterior.in/GetTransactionsByLabourExport.php",
        datatoSend
      )
      .then(function (response) {
        const data1 = response.data;

        if (data1.status === 1) {
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.json_to_sheet(data1.Data);
          XLSX.utils.book_append_sheet(wb, ws, "Labour");
          XLSX.writeFile(wb, "LabourTransactions.xlsx");
        }
        if (data1.status === 0) {
          toaster.push(
            <Notification type="error" header="Error" duration={1000}>
              No Records
            </Notification>,
            { placement: "topEnd" }
          );
        }
        setProcessing1(false);
      })
      .catch(function (error) {
        console.log(error);
        setProcessing1(false);
      });
  }

  const handleSearchforLabour = () => {
    if (selectedNameID === "") {
      toaster.push(
        <Notification type="error" header="Error" duration={1000}>
          Please enter Labour name
        </Notification>,
        { placement: "topEnd" }
      );
      setProcessing(false);
      return;
    }
    const datatoSend = { LabourID: selectedNameID, Month: selectedDate };
    console.log(datatoSend);
    axios
      .post(
        "https://api.laxmaninterior.in/GetMonthlyDataForLabour.php",
        datatoSend
      )
      .then(function (response) {
        const data1 = response.data;
        console.log(data1);
        if (data1.status === 1) {
          setdataList(data1.Data);
          setAttendance(data1.Attendance);
          setAmount(data1.Total);
        }
        if (data1.status === 0) {
          toaster.push(
            <Notification type="error" header="Error" duration={1000}>
              No records
            </Notification>,
            { placement: "topEnd" }
          );
        }
      })
      .catch(function (error) {
        console.log(error);
        toaster.push(
          <Notification type="error" header="Error" duration={1000}>
            {error}
          </Notification>,
          { placement: "topEnd" }
        );
      });
  };

  function handleExport1() {
    setProcessing1(true);
    if (selectedDateRange.length < 2) {
      toaster.push(
        <Notification type="error" header="Error" duration={1000}>
          Please select date
        </Notification>,
        { placement: "topEnd" }
      );
      setProcessing1(false);
      return;
    }

    const datatoSend = {
      StartDate: moment(selectedDateRange[0]).format("YYYY-MM-DD"),
      EndDate: moment(selectedDateRange[1]).format("YYYY-MM-DD"),
    };
    axios
      .post(
        "https://api.laxmaninterior.in/GetLabourTransactionByDateExport.php",
        datatoSend
      )
      .then(function (response) {
        const data1 = response.data;
        if (data1.status === 1) {
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.json_to_sheet(data1.Data);
          XLSX.utils.book_append_sheet(wb, ws, "Labour");
          XLSX.writeFile(wb, "LabourTransactions.xlsx");
        }
        if (data1.status === 0) {
          console.log(data1.error);
        }
        setProcessing1(false);
      })
      .catch(function (error) {
        console.log(error);
        setProcessing1(false);
      });
  }

  const handleSearchforLabourByDate = () => {
    setProcessing2(true);
    if (selectedDateRange.length < 2) {
      toaster.push(
        <Notification type="error" header="Error" duration={1000}>
          Please select date ranges
        </Notification>,
        { placement: "topEnd" }
      );
      setProcessing2(false);
      return;
    }

    const datatoSend = {
      StartDate: moment(selectedDateRange[0]).format("YYYY-MM-DD"),
      EndDate: moment(selectedDateRange[1]).format("YYYY-MM-DD"),
    };
    axios
      .post(
        "https://api.laxmaninterior.in/GetAllLabourBetweenDate.php",
        datatoSend
      )
      .then(function (response) {
        const data1 = response.data;
        console.log(data1);

        if (data1.status === 1) {
          data1.Data.forEach((r) => {
            setdataList2(data1.Data);
          });
          setAttendance(data1.Attendance);
          setAmount(data1.Total);
        }
        if (data1.status === 0) {
        }
        setProcessing2(false);
      })
      .catch(function (error) {
        console.log(error);
        setProcessing2(false);
      });
  };

  React.useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) getLabourList();
    return () => {
      isSubscribed = false;
    };
  }, []);

  return (
    <div>
      <Header>
        <h4 style={{ color: "white", fontSize: 25 }}>Track Attendance</h4>
      </Header>
      <div className="InputContainer">
        <Form.Group controlId="radioList">
          <RadioGroup
            name="radioList"
            inline
            appearance="picker"
            defaultValue="A"
            onChange={(e) => {
              handleRadio(e);
            }}
            value={radio}
          >
            <Radio value="A">Report by Labour</Radio>
            <Radio value="D">Date wise Search</Radio>
          </RadioGroup>

          <hr />
        </Form.Group>
        <Form layout="inline">
          {radio === "A" && (
            <>
              <Form.Group>
                <Form.ControlLabel>Date:</Form.ControlLabel>
                <DatePicker
                  oneTap
                  format="MMM-yyyy"
                  cleanable={false}
                  defaultValue={firstDay}
                  ranges={[]}
                  onSelect={(e) => setselectedDate(e)}
                  style={{ width: 200 }}
                />
              </Form.Group>
              <Form.Group>
                <Form.ControlLabel>Labour Name:</Form.ControlLabel>
                <SelectPicker
                  data={LabourList}
                  appearance="default"
                  placeholder="Select Labour"
                  style={{ width: 224 }}
                  value={selectedLabour}
                  onSelect={(e, Item) => {
                    setSelectedLabour(e);
                    setselectedNameID(Item.id);
                  }}
                />
                &nbsp;
                <IconButton
                  onClick={handleSearchforLabour}
                  loading={processing}
                  icon={<SearchIcon />}
                >
                  Search
                </IconButton>
                &nbsp;
                <Table2XLSX />
              </Form.Group>
            </>
          )}

          {radio === "D" && (
            <>
              <Form.Group>
                <Form.ControlLabel>Date Between:</Form.ControlLabel>
                <DateRangePicker
                  cleanable={false}
                  value={selectedDateRange}
                  onChange={setselectedDateRange}
                />
                &nbsp;
                <IconButton
                  onClick={handleSearchforLabourByDate}
                  loading={processing2}
                  icon={<SearchIcon />}
                >
                  Search
                </IconButton>
                &nbsp;
                <Table2XLSX />
              </Form.Group>
            </>
          )}
          <div
            style={{
              display: "inline",
              alignItems: "center",
            }}
          >
            {`Total Attendance : ${Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
              minimumFractionDigits: 2,
            }).format(attendance)}`}
            &nbsp; &nbsp;
            {`Salary : ${Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
              minimumFractionDigits: 2,
            }).format(amount)}`}
          </div>
        </Form>
      </div>
      <div className="InputContainer">
        {radio === "A" && (
          <Table striped bordered hover>
            <thead>
              <tr>
                {column.map((a) => (
                  <th key={a.field}>{a.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataList.map((a) => (
                <tr key={a.Date}>
                  <td>{a.Date}</td>
                  <td>{a.Attendance}</td>
                  <td>
                    {Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(a.PerDayRate)}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(a.Salary)}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(a.Tea)}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(a.Total)}
                  </td>
                  <td>{a.SiteName}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {radio === "D" && (
          <Table>
            <thead>
              <tr>
                {column2.map((a) => (
                  <th key={a.field}>{a.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataList2.map((a) => (
                <tr key={a.SrNo}>
                  <td>{a.Name}</td>
                  <td>{a.Date}</td>
                  <td>{a.Attendance}</td>
                  <td>
                    {Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(a.PerDayRate)}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(a.Salary)}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(a.Tea)}
                  </td>
                  <td>
                    {Intl.NumberFormat("en-IN", {
                      style: "currency",
                      currency: "INR",
                      minimumFractionDigits: 2,
                    }).format(a.Total)}
                  </td>
                  <td>{a.SiteName}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default ViewAttendance;
